import { z } from 'zod';
export const sendAdminNotificationRequestParamsSchema = z.object({
    data: z.any(),
});
export const sendAdminNotificationResponseSchema = z.void();
